import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  TextField,
  MenuItem,
  IconButton,
  Chip,
  Checkbox,
  FormControlLabel,
  Button,
  CircularProgress,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { axiosInstance } from "../../../services/axiosInstance";
import { endpoints } from "../../../services/endpoint";
import "./editqueue.css";
// ✅ EditQueuesPage Component
const EditQueuesPage = ({ queue, onClose, onUpdate }) => {
  // ✅ Initial values from queue prop
  const [name, setName] = useState(queue?.name || "");
  const [description, setDescription] = useState(queue?.description || "");
  const [hopName, setHopName] = useState(queue?.HoursOfOperationName || "");
  const [callername, setCallerName] = useState(
    queue?.outboundCallerIdName || ""
  );
  const [callernumber, setCallerNumber] = useState(
    queue?.outboundCallerIdNumber || ""
  );
  const [flowname, setFlowName] = useState(queue?.outboundFlowName || "");
  const [connectname, setConnectName] = useState(queue?.QuickConnectName ||"");
  const [selectedProfiles, setSelectedProfiles] = useState(
    queue?.quickConnectTypes || []
  );
  const [checked, setChecked] = useState(!!queue?.maxContacts);
  const [valuenumber, setValueNumber] = useState(queue?.maxContacts || 0);
  const [tags, setTags] = useState(queue?.tags || "");
  const [showTags, setShowTags] = useState(false);

  // ✅ Error handling
  const [errors, setErrors] = useState({});
  const [actionClicked, setActionClicked] = useState(null); 
  const [saveLoading, setSaveLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const instanceAlias = localStorage.getItem("instanceName");
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
 const EncryptedInstanceId=localStorage.getItem("EncryptedId")
 const email = localStorage.getItem("Email");
  const username = localStorage.getItem("username");
  // ✅ Initialize custom hours from existing config
  const [hoursOfOperation, setHoursOfOperation] = useState([]);
  const [OutboundCallerIdName, setOutboundCallerIdName] = useState([]);
   const [quickConnect, setQuickConnect] = useState([]);
  const handlehoplist = async () => {
    const payload = {
      instanceAlias,
      awsAccount: customerAWSAccountId,
      region,
       ID:EncryptedInstanceId,
    };
    try {
      const response = await axiosInstance.post(
        endpoints.addQueuehop.getAfterHours,
        payload
      );
      if (response.status === 200) {
        console.log("Data saved successfully:", response.data);
        const body = JSON.parse(response.data.body);
        const listedHours = body.ListedHoursOfOperation;

        console.log("Data fetched successfully:", listedHours);
        setHoursOfOperation(listedHours);
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error("Error saving user data:", error);
    }
  };
 const handleOutboundCallerIdName = async () => {
  const payload = {
    awsAccount: customerAWSAccountId,
    region,
    ID: EncryptedInstanceId,
  };

  try {
    const response = await axiosInstance.post(
      endpoints.outbound.CallerId,
      payload
    );

    if (response.data.statusCode === 200) {
      console.log("outboundcalleridname saved successfully:", response.data);

      const parsed = JSON.parse(response.data.body); // this is already an array of strings
      console.log("calleridname", parsed);

      setOutboundCallerIdName(parsed); // directly set the array
    } else {
      console.error("Unexpected response:", response);
    }
  } catch (error) {
    console.error("Error saving user data:", error);
  }
};

 const handleQuickConnect = async () => {
    const payload = {
        instanceAlias,
      awsAccount: customerAWSAccountId,
      region,
       ID:EncryptedInstanceId,
    };
    try {
      const response = await axiosInstance.post(
        endpoints.quickConnect.getQuickConnectName,
        payload
      );
      if (response.data.statusCode === 200) {
        const body = JSON.parse(response.data.body);
        setQuickConnect(body.QuickConnects);
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error(error);
    }
  };
 useEffect(() => {
    handlehoplist();
    handleOutboundCallerIdName();
    handleQuickConnect();
  }, []);
  const toggleTagsDisplay = () => setShowTags((prev) => !prev);

  // ✅ Quick connect selection
  const handleToggle = (profile) => {
    setSelectedProfiles((prev) =>
      prev.includes(profile)
        ? prev.filter((p) => p !== profile)
        : [...prev, profile]
    );
  };

  const handleClearSelection = () => {
    setSelectedProfiles([]);
  };

  // ✅ Increment / decrement max contacts
  const incrementValue = (e) => {
    e.preventDefault();
    setValueNumber((prev) => prev + 1);
  };
  const decrementValue = (e) => {
    e.preventDefault();
    setValueNumber((prev) => (prev > 0 ? prev - 1 : 0));
  };

  // ✅ Checkbox toggle
  const handleCheckboxChange = (e) => setChecked(e.target.checked);

  // ✅ Input handlers
  const handleNameChange = (e) => {
    setName(e.target.value);
    if (errors.name) setErrors((prev) => ({ ...prev, name: "" }));
  };

  const handleChange = (e) => {
    setCallerName(e.target.value);
  };

  const handleInputChange = (e) => {
    setValueNumber(Number(e.target.value));
  };
const validateName = (value) => {
    const trimmedValue = value.trim();
}

  const handleCancel = () => {
       setActionClicked("cancel");
    setCancelLoading(true);
    setTimeout(() => {
      setCancelLoading(false);
         setActionClicked(null);
      onClose(); // close edit mode
    }, 500);
  };

  const validateFields = () => {
    let newErrors = {};
    if (!name.trim()) newErrors.name = "Queue name is required";
    if (!description.trim()) newErrors.description = "Description is required";
    if (!hopName.trim()) newErrors.hopName = "Select Hours of Operation";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
const fetchQueues = async () => {
  const body = {
    ID:EncryptedInstanceId,
    awsAccount: customerAWSAccountId,
    region: region,
  };

  try {
    const response = await axiosInstance.post(
      endpoints.queuesDisplay.viewQueues,
      body
    );

    console.log("Response received:", response);

    if (response.data.statusCode === 200) {
      console.log("Successful response!");
      const data = JSON.parse(response.data.body);

      if (data.queues && Array.isArray(data.queues.DescribedQueues)) {
        const extractedData = data.queues.DescribedQueues.map((item) => {
          const quickConnectNames =
            item.QuickConnects && Array.isArray(item.QuickConnects)
              ? item.QuickConnects.map((qc) => qc.QuickConnectName).join(", ")
              : "No QuickConnects";

          const tags = item.Tags
            ? Object.entries(item.Tags)
                .map(([key, value]) => `${key}: ${value}`)
                .join(", ")
            : "No tags";

          return {
            name: item.Name,
            description: item.Description || "No description",
            HoursOfOperationName: item.HoursOfOperationName || "No hours set",
            QuickConnectName: quickConnectNames,
            maxContacts: item.MaxContacts || "-",
            status: item.Status || "UNKNOWN",
            tags,
            arn: item.QueueArn,
            timeZone: item.TimeZone || "No timezone",
            config: item.Config || {},
            lastModifiedTime: item.LastModifiedTime || "No modification time",
            outboundCallerIdName:
              item.OutboundCallerConfig?.OutboundCallerIdName || "-",
            outboundCallerIdNumber: item.OutboundCallerIdNumber || "-",
            outboundFlowName: item.OutboundFlowName || "-",
            quickConnectTypes: item.QuickConnects
              ? item.QuickConnects.map((qc) => qc.QuickConnectType)
              : ["No Quick Connects"],
          };
        });

        return extractedData;
      } else {
        console.warn("No queues found in response.");
        return [];
      }
    } else {
      console.error("API responded with non-200 status:", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching queues:", error);
    return [];
  }
};

//   // ✅ Save Handler
//   const handleSave = async () => {

// setActionClicked("save");
//     setSaveLoading(true);

//     const commonPayload = {
//       awsAccount: customerAWSAccountId,
//       InstanceAlias:instanceAlias,
//       region:region,
//       ID:EncryptedInstanceId,
//       UserName:username,
//       Email:email, 
//     };

//     try {
//       // 1️⃣ Update Queue name/description
//       if (name || description) {
//         const queuePayload = {
//           ...commonPayload,
//           OldQueueName: queue.name || name,
//           NewQueueName: name,
//           NewQueueDescription: description,
//           action: "updatequeue",
//         };

//         const response = await axiosInstance.post(
//           endpoints.addQueue.addqueues,
//           queuePayload
//         );
//         console.log("Queue update response:", response.data);
//       }

//       // 2️⃣ Update Hours of Operation
//       if (hopName) {
//         const hopPayload = {
//           ...commonPayload,
//           QueueName: name,
//           HOPName: hopName,
//           action: "update_queue_hop",
//         };
//         const hopRes = await axiosInstance.post(
//           endpoints.addQueue.addqueues,
//           hopPayload
//         );
//         console.log("HOP update response:", hopRes.data);
//       }

//       // 3️⃣ Outbound Caller Config
//       if (callername || callernumber || flowname) {
//         const outboundPayload = {
//           ...commonPayload,
//           NewOutboundCallerIdName: callername,
//           NewOutboundCallerIdNumber: callernumber,
//           NewOutboundFlowName: flowname,
//           QueueName: name,
//           action: "updateQueueOutboundCallerConfig",
//         };
//         const outboundRes = await axiosInstance.post(
//           endpoints.addQueue.addqueues,
//           outboundPayload
//         );
//         console.log("Outbound Caller update response:", outboundRes.data);
//       }

//       // 4️⃣ Handle Quick Connect changes
//       const currentConnects = connectname
//         ? connectname.split(",").map((qc) => qc.trim())
//         : [];

//       const previousConnects = JSON.parse(
//         localStorage.getItem("previousConnects") || "[]"
//       );

//       const addedConnects = currentConnects.filter(
//         (qc) => !previousConnects.includes(qc)
//       );
//       const removedConnects = previousConnects.filter(
//         (qc) => !currentConnects.includes(qc)
//       );

//       // Disassociate removed Quick Connects
//       if (removedConnects.length > 0) {
//         const disassociatePayload = {
//           ...commonPayload,
//           QueueName: name,
//           QuickConnectNames: removedConnects,
//           action: "dissociate_quickconnect",
//         };
//         const disassociateRes = await axiosInstance.post(
//           endpoints.addQueue.addqueues,
//           disassociatePayload
//         );
//         console.log("Removed Quick Connects:", disassociateRes.data);
//       }

//       // Associate new Quick Connects
//       if (addedConnects.length > 0) {
//         const associatePayload = {
//           ...commonPayload,
//           QueueName: name,
//           QuickConnectNames: addedConnects,
//           action: "associate_quickconnect",
//         };
//         const associateRes = await axiosInstance.post(
//           endpoints.addQueue.addqueues,
//           associatePayload
//         );
//         console.log("Added Quick Connects:", associateRes.data);
//       }

//       localStorage.setItem(
//         "previousConnects",
//         JSON.stringify(currentConnects)
//       );

//       // 5️⃣ Update Max Contacts if set
//       if (checked && valuenumber) {
//         const maxContactsPayload = {
//           ...commonPayload,
//           QueueName: name,
//           MaxContacts: valuenumber,
//           action: "updateQueueMaxContacts",
//         };
//         const maxRes = await axiosInstance.post(
//           endpoints.addQueue.addqueues,
//           maxContactsPayload
//         );
//         console.log("Max Contacts updated:", maxRes.data);
//       }

//       // 6️⃣ Fetch updated queue list
//       const fetchPayload = { ...commonPayload, InstanceAlias: instanceAlias };
//       const fetchRes = await axiosInstance.post(
//         endpoints.queuesDisplay.viewQueues,
//         fetchPayload
//       );

//       if (fetchRes.status === 200) {
//         console.log("Fetched updated queues:", fetchRes.data);

//         const data = JSON.parse(fetchRes.data.body);

//         if (data.queues && Array.isArray(data.queues.DescribedQueues)) {
//           const extractedData = data.queues.DescribedQueues.map((item) => {
//             const quickConnectNames =
//               item.QuickConnects?.map((qc) => qc.QuickConnectName).join(", ") ||
//               "No Quick Connects";
//             const tags = item.Tags
//               ? Object.entries(item.Tags)
//                   .map(([key, value]) => `${key}: ${value}`)
//                   .join(", ")
//               : "No tags";

//             return {
//               name: item.Name,
//               description: item.Description || "No description",
//               HoursOfOperationName: item.HoursOfOperationName || "No hours set",
//               QuickConnectName: quickConnectNames,
//               status: item.Status || "UNKNOWN",
//               maxContacts: item.MaxContacts || "-",
//               tags,
//               arn: item.QueueArn,
//               timeZone: item.TimeZone || "No timezone",
//               config: item.Config || {},
//               lastModifiedTime: item.LastModifiedTime || "No modification time",
//               outboundCallerIdName:
//                 item.OutboundCallerConfig?.OutboundCallerIdName || "-",
//               outboundCallerIdNumber: item.OutboundCallerIdNumber || "-",
//               outboundFlowName: item.OutboundFlowName || "-",
//               quickConnectTypes: item.QuickConnects?.map(
//                 (qc) => qc.QuickConnectType
//               ) || ["No Quick Connects"],
//             };
//           });

//           const updatedList = await fetchQueues();
// if (onUpdate) onUpdate(updatedList);

//           }
//       }

//       // ✅ Finally close after successful save
//       setSaveLoading(false);
//       onClose();
//     } catch (error) {
//       console.error("Error while updating queue:", error);
//       setSaveLoading(false);
//       setActionClicked(null);
//     }
//   };
const handleSave = async () => {
  setActionClicked("save");
  setSaveLoading(true);

  const commonPayload = {
    awsAccount: customerAWSAccountId,
    InstanceAlias: instanceAlias,
    region,
    ID: EncryptedInstanceId,
    UserName: username,
    Email: email,
  };

  try {
    // 1️⃣ Update Queue details
    if (name || description || hopName || callername || callernumber || flowname) {
      const queuePayload = {
        ...commonPayload,
        OldQueueName: queue.name || name,
        NewQueueName: name,
        NewQueueDescription: description,
        SelectedHOPName: hopName,
        OutboundCallerIdName: callername,
        OutboundCallerIdNumber: callernumber,
        MaxContacts: valuenumber,
        OutboundFlowName: flowname,
        action: "Update",
      };

      const response = await axiosInstance.post(
        endpoints.addQueue.addqueues,
        queuePayload
      );
      console.log("Queue update response:", response.data);
    }

    // 2️⃣ Handle Quick Connect associations/disassociations
    const currentConnects = connectname
      ? connectname.split(",").map((qc) => qc.trim())
      : [];

    const previousConnects = JSON.parse(
      localStorage.getItem("previousConnects") || "[]"
    );

    const addedConnects = currentConnects.filter(
      (qc) => !previousConnects.includes(qc)
    );
    const removedConnects = previousConnects.filter(
      (qc) => !currentConnects.includes(qc)
    );

    // Disassociate removed Quick Connects
    if (removedConnects.length > 0) {
      const disassociatePayload = {
        ...commonPayload,
        QueueName: name,
        QuickConnectNames: removedConnects,
        action: "dissociate_quickconnect",
      };
      const disassociateRes = await axiosInstance.post(
        endpoints.addQueue.addqueues,
        disassociatePayload
      );
      console.log("Removed Quick Connects:", disassociateRes.data);
    }

    // Associate new Quick Connects
    if (addedConnects.length > 0) {
      const associatePayload = {
        ...commonPayload,
        QueueName: name,
        QuickConnectNames: addedConnects,
        action: "associate_quickconnect",
      };
      const associateRes = await axiosInstance.post(
        endpoints.addQueue.addqueues,
        associatePayload
      );
      console.log("Added Quick Connects:", associateRes.data);
    }

    // Update localStorage for next comparison
    localStorage.setItem("previousConnects", JSON.stringify(currentConnects));

    // 3️⃣ Fetch updated queue list
    const fetchPayload = { ...commonPayload, InstanceAlias: instanceAlias };
    const fetchRes = await axiosInstance.post(
      endpoints.queuesDisplay.viewQueues,
      fetchPayload
    );

    if (fetchRes.status === 200 && fetchRes.data?.body) {
      console.log("Fetched updated queues:", fetchRes.data);

      const data = JSON.parse(fetchRes.data.body);
      if (data.queues && Array.isArray(data.queues.DescribedQueues)) {
        const extractedData = data.queues.DescribedQueues.map((item) => {
          const quickConnectNames =
            item.QuickConnects?.map((qc) => qc.QuickConnectName).join(", ") ||
            "No Quick Connects";
          const tags = item.Tags
            ? Object.entries(item.Tags)
                .map(([key, value]) => `${key}: ${value}`)
                .join(", ")
            : "No tags";

          return {
            name: item.Name,
            description: item.Description || "No description",
            HoursOfOperationName: item.HoursOfOperationName || "No hours set",
            QuickConnectName: quickConnectNames,
            status: item.Status || "UNKNOWN",
            maxContacts: item.MaxContacts || "-",
            tags,
            arn: item.QueueArn,
            timeZone: item.TimeZone || "No timezone",
            config: item.Config || {},
            lastModifiedTime: item.LastModifiedTime || "No modification time",
            outboundCallerIdName:
              item.OutboundCallerConfig?.OutboundCallerIdName || "-",
            outboundCallerIdNumber:
              item.OutboundCallerConfig?.OutboundCallerIdNumber || "-",
            outboundFlowName: item.OutboundFlowName || "-",
            quickConnectTypes:
              item.QuickConnects?.map((qc) => qc.QuickConnectType) ||
              ["No Quick Connects"],
          };
        });

        // 4️⃣ Update parent component after successful save
        const updatedList = await fetchQueues();
        if (onUpdate) onUpdate(updatedList);
      }
    }

    // ✅ Close modal after successful save
    setSaveLoading(false);
    onClose();
  } catch (error) {
    console.error("Error while updating queue:", error);
    setSaveLoading(false);
    setActionClicked(null);
  }
};

  return (
     <Container className="editqueue-content-container">
      <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
  {/* Back Arrow in a circular button */}
  <IconButton
    onClick={onClose}
    size="medium"
    sx={{
      border: "1px solid #ccc",       // border color
      borderRadius: "50%",            // makes it circular
      padding: 1,                     // inner spacing
      bgcolor: "#f5f5f5",             // background color
      "&:hover": { bgcolor: "#e0e0e0" } // hover effect
    }}
  >
    <ArrowBackIcon />
  </IconButton>

  {/* Title */}
  <Typography variant="h4" className="phone-text">Edit {queue?.name || "Queue"}</Typography>
   
</Box>
    <div className="editqueue-form-section">
        <h3>Queue details</h3>
        <div className="editqueue-form-fields">
          <TextField
            label="Name"
          
            required
          placeholder="Enter Name"
          
            value={name}
            onChange={handleNameChange}
            helperText={errors.name}
            error={!!errors.name}
          />
          <TextField
            label="Description"
            placeholder="Enter description"
            required
            
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            error={!!errors.description}
            helperText={errors.description}
          />
     

        <div>
                 <b className="boldheadingfont">Hours of operation</b>
                 <Typography className="additional-text">
                   Set the hours of operation and timezone for a queue.{" "}
                   <a
                     href="https://docs.aws.amazon.com/connect/latest/adminguide/set-hours-operation.html"
                     target="_blank"
                     rel="noreferrer"
                     className="addqueue-learnmore"
                   >
                     Learn More
                   </a>
                 </Typography>
                 <br></br>
        <TextField
          label="Search hours of operation"
          placeholder="Select hours of operation"
          required
          value={hopName}
          error={!!errors.hopName}
          helperText={errors.hopName}
          onChange={(e) => setHopName(e.target.value)}
          select
         
        >
          {hoursOfOperation.map((profile, index) => (
            <MenuItem key={index} value={profile}>
              {profile}
            </MenuItem>
          ))}
        </TextField>
        </div>
      </div>
</div>
      {/* ✅ Settings Section */}
      <br />
      <div className="setting-form-section">
        <h3>Settings</h3>
        <b className="boldheadingfontedit">Outbound caller configuration</b>
        <br></br>
               <Typography className="additional-text">
                 Set the default caller ID name that will display to customers.{" "}
                 <a
                   href="https://docs.aws.amazon.com/connect/latest/adminguide/queues-callerid.html"
                   target="_blank"
                   rel="noreferrer"
                   className="addqueue-learnmore"
                 >
                   Learn More
                 </a>
               </Typography>
        <br />
        <Box className="form-row">
          {/* Caller ID name */}
          <div className="form-group">
           <Box                      display="flex"
                                   gap={1}
                                   mt={2}
                                 >
            <TextField
              label="  Default caller ID name"
            placeholder="Enter caller ID name"
              value={callername}
              onChange={handleChange}
            
            />
        

        
            
            <TextField
              label=" Outbound caller ID number"
             placeholder="Search for phone numbers"
              value={callernumber}
              onChange={(e) => setCallerNumber(e.target.value)}
              select
            
            >
              {OutboundCallerIdName.map((profile, index) => (
                <MenuItem key={index} value={profile}>
                  {profile}
                </MenuItem>
              ))}
            </TextField>
          

         
          
            <TextField
              label=" Outbound caller flow"
            placeholder="Search for flow"
              value={flowname}
              onChange={(e) => setFlowName(e.target.value)}
              select
            
            >
              <MenuItem value="Default outbound">Default outbound</MenuItem>
            </TextField>
       
        </Box>
</div>
</Box>
        
        <br />
        <Typography className="editquick-heading">Quick connects</Typography>
        <Typography className="additional-text">
          Choose the quick connects that agents who are working this queue will
          see in their CCP.
          <a
            href="https://docs.aws.amazon.com/connect/latest/adminguide/quick-connects.html"
            target="_blank"
            className="editqueuelearnmore"
          >
            Learn More.
          </a>
        </Typography>
      
        <div>
           <Box mt={2} >
          <TextField
            className="queue-form-field"
            label={
              <span>
                {selectedProfiles.length > 0 && (
                  <IconButton onClick={handleClearSelection} size="small">
                    <CancelIcon fontSize="small" />
                  </IconButton>
                )}
                Search for quick connects
              </span>
            }
           placeholder=" Search for quick connects"
            value={connectname}
            onChange={(e) => setConnectName(e.target.value)}
            select
           
            helperText={
              selectedProfiles.length === 0
                ? "Select profiles from the dropdown"
                : ""
            }
          >
            {quickConnect.map((profile, index) => (
              <MenuItem
                key={index}
                value={profile}
                onClick={() => handleToggle(profile)}
              >
                {profile}
              </MenuItem>
            ))}
          </TextField>
          </Box>
          <Box mt={1}>
            {selectedProfiles.map((profile) => (
              <Chip
                key={profile}
                label={profile}
                onDelete={() => handleToggle(profile)}
              
                style={{ margin: "0 4px 4px 0" }}
              />
            ))}
          </Box>
        </div>

      
                <Typography className="headings-edit">Maximum contacts in queue</Typography>
                <Typography className="additional-text">
                  Set the maximum contacts allowed to be in the queue.{" "}
                  <a
                    href="https://docs.aws.amazon.com/connect/latest/adminguide/set-maximum-queue-limit.html"
                    target="_blank"
                    rel="noreferrer"
                    className="addqueue-learnmore"
                  >
                    Learn More
                  </a>
                </Typography>
        <Box className="queue-limit-container" mt={1} mr={75}>
          <FormControlLabel
            control={
              <Checkbox
                className="checkstylingaddqueue"
                checked={checked}
                onChange={handleCheckboxChange}
              />
            }
            label="Set a limit across all channels"
            className="limit-checkbox"
          />
          {checked && (
            <Box className="number-input-box">
             <TextField
  label="Maximum contacts in queue"
  placeholder="Maximum contacts in queue"
  required={checked}
  value={valuenumber}
  onChange={handleInputChange}
  error={!!errors.valuenumber}
  helperText={errors.valuenumber}
  type="number"   // ✅ built-in number input
  InputProps={{
    inputProps: { min: 0, max: 100 },
    classes: { input: "number-input" }, // optional custom CSS
  }}
/>

            </Box>
          )}
        </Box>

        {/* ✅ Advanced Settings */}
        <div>
          <Box
            display="flex"
            alignItems="center"
            onClick={toggleTagsDisplay}
            style={{ cursor: "pointer", marginBottom: "10px" }}
          >
            <Typography variant="h6" className="editqueue-advancedtext">
              Show advanced settings
            </Typography>
            <IconButton size="small">
              {showTags ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
          </Box>

          {showTags && (
            <>
              <Typography className="editqueue-tagheading">
                Tags (Optional)
              </Typography>
              {typeof tags === "string" && tags.length > 0 && (
                <Box className="tags-display" mt={2}>
                  <Typography
                    variant="subtitle1"
                    className="editqueues-tagstext"
                  >
                    Selected tags
                  </Typography>
                  <Typography
                    variant="body1"
                    className="editqueuetagsdisplaying"
                  >
                    {tags}
                  </Typography>
                </Box>
              )}
            </>
          )}
        </div>
      </div>

      {/* ✅ Action Buttons */}
      <br />
      <div className="buttons-editqueue">
        <Button
          onClick={handleCancel}
          // className="editqueue-cancel-button"
        
             disabled={actionClicked === "save" || cancelLoading}
                >
                  <span className="adduser-button-content">
                    {actionClicked === "cancel" ? (
                      <CircularProgress size={18} style={{ color: "red" }} />
                    ) : (
                      "Cancel"
                    )}
                            </span>
                          </Button>
        <Button
          onClick={handleSave}
        
         variant="contained"
                       disabled={actionClicked === "cancel" || saveLoading}
               >
                 <span className="adduser-button-content">
                   {actionClicked === "save" ? (
                     <CircularProgress size={18} style={{ color: "white" }} />
                   ) : (
                     "Save"
                   )}
                           </span>
        </Button>
      </div>
      <br />
    </Container>
  );
};

export default EditQueuesPage;
